import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { CalendarModule } from '@finder/shared/components/calendar/calendar.module';
import { CalendarRoutingModule } from './calendars-routing.module';
import { CalendarsComponent } from './calendars.component';
import { CalendarsDayModule } from './components/day/day.module';
import { CalendarsFiltersModule } from './components/filters/calendar-filters.module';
import { CalendarsFiveDayModule } from './components/five-day/five-day.module';
import { CalendarsService } from './services/calendar.service';
import { ComponentsModule } from '@finder/shared/components/components.module';
import { DatePickerModalComponent } from '@finder/features/calendars/components/date-picker-modal/date-picker-modal.component';
import { DatePickerWrapperModule } from '@finder/shared/components/date-picker-wrapper/date-picker-wrapper.module';
import { FilterEmitterService } from '@finder/shared/services/filter-emitter-service/filter-emitter.service';
import { AnchorModule } from '@finder/shared/components/anchor/anchor.module';
import { BreadcrumbModule } from '@finder/shared/components/breadcrumb/breadcrumb.module';
import { FinderIntersectionModule } from '@finder/shared/directives/intersection/intersection.module';
import { SwitchButtonModule } from '@finder/shared/components/switch-button/switch-button.module';
import { TitleModule } from '@finder/shared/components/title/title.module';
import { FontIconModule } from '@finder/shared/components/font-icon/font-icon.module';
import { MobileFiltersComponent } from './components/mobile-filters/mobile-filters.component';
import { StickyBarComponent } from '@finder/features/calendars/components/sticky-bar/sticky-bar.component';
import { ViewAllModalComponent } from './components/view-all/view-all.component';

const exportableComponents = [
    CalendarsComponent,
    DatePickerModalComponent,
    MobileFiltersComponent,
    StickyBarComponent,
    ViewAllModalComponent
];

const exportableModules = [
    CalendarModule,
    CalendarsDayModule,
    CalendarsFiltersModule,
    CalendarsFiveDayModule,
    ComponentsModule,
    DatePickerWrapperModule,
    AnchorModule,
    BreadcrumbModule,
    FinderIntersectionModule,
    SwitchButtonModule,
    TitleModule,
    FontIconModule
];

@NgModule({
    imports: [
        CommonModule,
        CalendarRoutingModule,
        ...exportableModules,
    ],
    declarations: [
        exportableComponents,
    ],
    providers: [
        CalendarsService,
        DatePipe,
        FilterEmitterService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    exports: [
        ...exportableComponents
    ]
})
export class CalendarsModule { }
